export default "__VITE_ASSET__BUmGJ9m7__"